// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GatewayClaimSearchModel } from './gatewayClaimSearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest {
    'start'?: number;
    'pageSize'?: number;
    'searchModel': GatewayClaimSearchModel | null;
    'filterByClaimGroup'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest>> = [
        {
            "name":     "start",
            "baseName": "start",
            "type":     "number"
        },
        {
            "name":     "pageSize",
            "baseName": "pageSize",
            "type":     "number"
        },
        {
            "name":     "searchModel",
            "baseName": "searchModel",
            "type":     "GatewayClaimSearchModel"
        },
        {
            "name":     "filterByClaimGroup",
            "baseName": "filterByClaimGroup",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest.attributeTypeMap;
    }
}
